module.exports = "pegasus_template/assets/preview-22.png";